import { render, staticRenderFns } from "./PunctuationMarks.vue?vue&type=template&id=2d511760&lang=pug&"
import script from "./PunctuationMarks.vue?vue&type=script&lang=js&"
export * from "./PunctuationMarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports